import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//自定义css
import './assets/css/base.css'
//阿里icon
import './assets/css/icon/iconfont.css'
//typo.css
import "./assets/css/typo.css";
//semantic-ui
import 'semantic-ui-css/semantic.min.css'
//element-ui
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//moment
import './util/dateTimeFormatUtils.js'
//v-viewer
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
//directive
import './util/directive'
//懒加载
import VueLazyload from 'vue-lazyload'

Vue.use(Element)
Vue.use(Viewer)
Vue.use(VueLazyload, {
	preLoad: 1.2,
	loading: require('./assets/img/loading.gif'),
})

Vue.prototype.msgSuccess = function (msg) {
	this.$message.success(msg)
}

Vue.prototype.msgError = function (msg) {
	this.$message.error(msg)
}

Vue.prototype.msgInfo = function (msg) {
	this.$message.info(msg);
}

const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
//滚动至页面顶部，使用 Element-ui 回到顶部 组件中的算法
Vue.prototype.scrollToTop = function () {
	const el = document.documentElement
	const beginTime = Date.now()
	const beginValue = el.scrollTop
	const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16))
	const frameFunc = () => {
		const progress = (Date.now() - beginTime) / 500;
		if (progress < 1) {
			el.scrollTop = beginValue * (1 - easeInOutCubic(progress))
			rAF(frameFunc)
		} else {
			el.scrollTop = 0
		}
	}
	rAF(frameFunc)
}


Vue.config.productionTip = false
// 修复 MetingJS 在 disconnectedCallback 时可能 this.aplayer 未定义导致报错
function patchMetingDisconnect() {
	try {
		const C = window.customElements && window.customElements.get && window.customElements.get('meting-js')
		if (C && C.prototype && !C.prototype.__patchedDisconnect) {
			const orig = C.prototype.disconnectedCallback
			C.prototype.disconnectedCallback = function () {
				try {
					if (orig) orig.call(this)
				} catch (e) {
					try {
						if (this.aplayer && typeof this.aplayer.destroy === 'function') this.aplayer.destroy()
					} catch (e2) {
						console.warn('Meting disconnectedCallback error', e2)
					}
				}
			}
			C.prototype.__patchedDisconnect = true
		}
	} catch (e) {
		// ignore
	}
}
window.addEventListener('DOMContentLoaded', patchMetingDisconnect)
window.addEventListener('load', patchMetingDisconnect)
setTimeout(patchMetingDisconnect, 1000)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
